import { React, useState, useContext, useEffect } from 'react'
import { Button, Icon, Table, Pagination, Form } from 'semantic-ui-react'
import { DebounceInput } from 'react-debounce-input'
import { useSelector } from 'react-redux'
import { GetPaginationDevicesList } from '../../../../services/device-page-list'
import { DEVICE_STATUS_ENUM } from '../../../../services/device'
import { DeviceViewContext } from '../device-info-view/deviceView'
import styles from '../device-info-view/device-view.module.css'
import classes from './devicelist.module.css'
import { GetAllCustomers } from '../../../../services/customer'
import IntelMsg from '../../../ItelMsg'
import { GetCustomerDevices } from '../../../../services/asset'
import { store, history } from '../../../../redux/store'
import { setDeviceData } from '../../../../redux/actions/deviceData'
import { primaryColor } from '../../../../constants'

const { dispatch } = store

const DeviceList = () => {
  const productName = localStorage.getItem('product')
  const { userEmail } = useSelector((deviceStore) => ({
    userEmail: deviceStore.auth.userEmail,
  }))
  const [deviceList, setDeviceList] = useState([])
  const [pageSize] = useState(10)
  const [noOfPages, setNoOfPages] = useState(0)
  const [activePage, setActivePage] = useState(0)
  const [selectState, setSelectState] = useState('all,all')
  // eslint-disable-next-line no-unused-vars
  const [customer, setCustomer] = useState('')

  const criteria = [
    { key: 1, text: 'ID', value: 'id' },
    { key: 2, text: 'Name', value: 'name' },
    { key: 3, text: 'Status', value: 'status' },
    { key: 4, text: 'IMEI', value: 'imei' },
  ]

  const status = [
    { key: 1, text: 'Offline', value: 'OFFLINE' },
    { key: 2, text: 'Connected', value: 'CONNECTED' },
    { key: 3, text: 'Installed', value: 'INSTALLED' },
    { key: 4, text: 'Configured', value: 'CONFIGURED' },
  ]

  const [searchTerm, setSearchTerm] = useState('')
  const [searchCriteria, setSearchCriteria] = useState('id')
  const [searchStatus, setSearchStatus] = useState('INSTALLED')
  const [searchName, setSearchName] = useState('')
  const [searchId, setSearchId] = useState('')
  const [searchImei, setSearchImei] = useState('')
  const [customersList, setCustomersList] = useState([])

  const handleChange = (event) => {
    setSearchTerm(event.target.value.replace(/[^\w\s]/gi, ' '))
  }

  const handleSelect = (e) => {
    setSearchCriteria(e.target.outerText.toLocaleLowerCase())
    // // setSearchTerm(searchTerm)
    // setSearchName(searchTerm)
    // setSearchId(searchTerm)
    // setSearchStatus(searchTerm)
    // if (searchCriteria === 'name' || searchCriteria === 'id') {
    setSearchTerm('')
    setSearchName('')
    handleClear()
    // }
  }

  const handleStatusSelect = (e) => {
    setSearchTerm(e.target.outerText.toUpperCase())
  }

  const { setViewDevice, viewDevice } = useContext(DeviceViewContext)
  const { setViewDevice2, viewDevice2, setCustomerId } =
    useContext(DeviceViewContext)

  useEffect(() => {
    if (searchCriteria === 'status') {
      setSearchStatus(`${`${searchTerm.toUpperCase().split(' ').join('')}`}`)
    } else if (searchCriteria === 'name') {
      setSearchName(`${searchTerm}`)
    } else if (searchCriteria === 'id') {
      setSearchId(`${searchTerm.toUpperCase().split(' ').join('')}`)
    } else if (searchCriteria === 'imei') {
      setSearchImei(`${searchTerm.toUpperCase().split(' ').join('')}`)
    } else {
      setSearchStatus('')
      setSearchName('')
      setSearchImei('')
      setSearchId('')
    }
  }, [searchTerm])

  useEffect(() => {
    if (userEmail) {
      setActivePage(0)
      GetAllCustomers(userEmail, productName).then((data) => {
        console.log('Customer List', data)
        setCustomersList(data || [])
      })
    }
  }, [userEmail])

  const handleClear = () => {
    localStorage.setItem('clear', true)
    GetPaginationDevicesList(
      userEmail,
      productName,
      activePage,
      pageSize,
      null,
      null,
      searchTerm.split(' ').join('') === ''
        ? null
        : searchId.split(' ').join(''),
      customer,
    ).then((data) => {
      const res = data.data
      setDeviceList(
        res.map((object) => ({
          ...object,
          imei: object['device name'].substring(
            5,
            object['device name'].length,
          ),
        })),
      )
      setNoOfPages(data['no of pages'])
      setSearchId(searchTerm.toLocaleUpperCase())
    })
  }

  useEffect(() => {
    if (userEmail) {
      if (searchCriteria === 'status') {
        GetPaginationDevicesList(
          userEmail,
          productName,
          activePage,
          pageSize,
          searchTerm.split(' ').join('') === ''
            ? null
            : searchStatus.split(' ').join(''),
          null,
          null,
          customer,
        ).then((data) => {
          // TOTO - AT-32
          const res = data.data
          setDeviceList(
            res.map((object) => ({
              ...object,
              imei: object['device name'].substring(
                5,
                object['device name'].length,
              ),
            })),
          )
          setNoOfPages(data['no of pages'])
          setSearchStatus(searchTerm.toLocaleUpperCase())
        })
      } else if (searchCriteria === 'name') {
        GetPaginationDevicesList(
          userEmail,
          productName,
          activePage,
          pageSize,
          null,
          searchTerm.split(' ').join('') === ''
            ? null
            : searchName.split(' ').join(''),
          null,
          customer,
        ).then((data) => {
          const res = data.data
          setDeviceList(
            res.map((object) => ({
              ...object,
              imei: object['device name'].substring(
                5,
                object['device name'].length,
              ),
            })),
          )
          setNoOfPages(data['no of pages'])
          setSearchName(searchTerm)
        })
      } else if (searchCriteria === 'id') {
        GetPaginationDevicesList(
          userEmail,
          productName,
          activePage,
          pageSize,
          null,
          null,
          searchTerm.split(' ').join('') === ''
            ? null
            : searchId.split(' ').join(''),
          customer,
        ).then((data) => {
          console.log('intellij', data)
          const res = data.data
          setDeviceList(
            res.map((object) => ({
              ...object,
              imei: object['device name'].substring(
                5,
                object['device name'].length,
              ),
            })),
          )
          setNoOfPages(data['no of pages'])
          setSearchId(searchTerm.toLocaleUpperCase())
        })
      } else if (searchCriteria === 'imei') {
        GetPaginationDevicesList(
          userEmail,
          productName,
          activePage,
          pageSize,
          null,
          null,
          searchTerm.split(' ').join('') === ''
            ? null
            : searchImei.split(' ').join(''),
          customer,
        ).then((data) => {
          const res = data.data
          setDeviceList(
            res.map((object) => ({
              ...object,
              imei: object['device name'].substring(
                5,
                object['device name'].length,
              ),
            })),
          )
          setNoOfPages(data['no of pages'])
          setSearchImei(searchTerm.toLocaleUpperCase())
        })
      }
    }
  }, [
    userEmail,
    activePage,
    searchStatus,
    searchName,
    searchImei,
    searchId,
    customer,
  ])

  const handleSaveCustomerSelect = (e) => {
    const customerDetails = JSON.parse(e)
    setSelectState(
      `${customerDetails.c_id},${customerDetails.c_name},${customerDetails.c_email},${customerDetails.c_tenant}`,
    )
    setCustomer(customerDetails.c_id)
    setCustomerId(customerDetails.c_id)
    if (customerDetails.c_name !== 'none') {
      GetCustomerDevices(
        customerDetails.c_email,
        localStorage.getItem('product'),
        activePage,
        pageSize,
        customerDetails.c_id,
      ).then((_data) => {
        setActivePage(0)
        const res = _data.data
        setDeviceList(
          res.map((object) => ({
            ...object,
            imei: object['device name'].substring(
              5,
              object['device name'].length,
            ),
          })),
        )
        setNoOfPages(_data['no of pages'])
      })
    }
  }

  setViewDevice(false)
  setViewDevice2(false)
  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    localStorage.getItem('customerTank') !== null &&
      localStorage.getItem('customerTank') !== '' &&
      !viewDevice &&
      !viewDevice2 &&
      handleSaveCustomerSelect(localStorage.getItem('customerTank'))
  }, [viewDevice, viewDevice2])

  const handleCustomerSelect = (e) => {
    const [id, name, customeremail, tenant] = e.target.value.split(',')
    const customerDetails = {
      c_id: id,
      c_name: name,
      c_email: customeremail,
      c_tenant: tenant,
    }
    localStorage.setItem('customerTank', JSON.stringify(customerDetails))
    setCustomer(id)
    setCustomerId(id)
    setSelectState(e.target.value)
    console.log(id, name)
    if (name !== 'none') {
      GetCustomerDevices(
        customeremail,
        localStorage.getItem('product'),
        activePage,
        pageSize,
        id,
      ).then((_data) => {
        setActivePage(0)
        const res = _data.data
        setDeviceList(
          res.map((object) => ({
            ...object,
            imei: object['device name'].substring(
              5,
              object['device name'].length,
            ),
          })),
        )
        setNoOfPages(_data['no of pages'])
      })
    } else {
      setNoOfPages(0)
      setDeviceList([])
    }
  }

  const onTroubleshootClick = (item) => {
    dispatch(setDeviceData(item))
    setViewDevice(true)
  }

  const onConfigureClick = (item) => {
    dispatch(setDeviceData(item))
    setViewDevice2(true)
  }

  const handleStatusStyle = (condition) => {
    if (condition === 'CONFIGURED') {
      return {
        color: 'blue',
      }
    }
    if (condition === 'OFFLINE') {
      return {
        color: 'red',
      }
    }
    if (condition === 'INSTALLED')
      return {
        color: 'green',
      }
    return {
      color: 'orange',
    }
  }

  const filteringCriteria = function (prop) {
    if (searchCriteria === 'status') {
      return prop['device status']
        .toLocaleLowerCase()
        .includes(searchTerm.toLocaleLowerCase().split(' ').join(''))
    }
    if (searchCriteria === 'name') {
      if (prop['device label']) {
        return prop['device label']
          .toUpperCase()
          .includes(searchTerm.toUpperCase().split(' ').join(''))
      }
    }
    if (searchCriteria === 'imei') {
      if (prop.imei) {
        return prop.imei
          .toUpperCase()
          .includes(searchTerm.toUpperCase().split(' ').join(''))
      }
    }
    return prop['device name'] !== null
      ? prop['device name']
          .toLocaleLowerCase()
          .includes(searchTerm.toLocaleLowerCase().split(' ').join(''))
      : ''
  }

  const onChange = (e, pageInfo) => {
    setActivePage(pageInfo.activePage - 1)
  }

  const listItems = deviceList ? (
    deviceList
      .filter((item) => filteringCriteria(item))
      .map((item) => (
        <Table.Row key={item['device id']}>
          <Table.Cell>
            {item['device label'] === null ||
            item['device label'] === '' ||
            item['device label'] === 'null'
              ? item['device name']
              : item['device label']}
          </Table.Cell>
          <Table.Cell>{item['device name']}</Table.Cell>
          <Table.Cell>{item.imei}</Table.Cell>
          <Table.Cell
            style={handleStatusStyle(item['device status'])}
            width={1}
          >
            <IntelMsg id={item['device status']} />
          </Table.Cell>
          {getActions(
            item['device status'] || 'CONNECTED',
            () => onConfigureClick(item),
            () => onTroubleshootClick(item),
          )}
        </Table.Row>
      ))
  ) : (
    <Table.Row>
      <Table.Cell colSpan="4">
        <p style={{ textAlign: 'center' }}>
          <strong>
            <IntelMsg id="thereIsNoDevicesToShow" />
          </strong>
        </p>
      </Table.Cell>
    </Table.Row>
  )

  return (
    <>
      <div>
        <h1 className={styles.head}>Device Provisioning</h1>
        <Form>
          <Form.Group className={styles.formm} inline widths="equals">
            <span className={styles.span}>Customer Name</span>
            <select
              value={selectState}
              onChange={handleCustomerSelect}
              style={{ width: 300, height: 40 }}
            >
              <option selected value=",">
                NONE
              </option>
              {customersList.map((item) => (
                <option
                  key={item.title}
                  value={`${item.tbCustomerId},${item.title},${item.email},${item.tenantId}`}
                >
                  {item.title}
                </option>
              ))}
            </select>
          </Form.Group>
          <Form.Group className={styles.formm} inline widths="equals">
            <span className={styles.span}>Select Your Search Criteria </span>
            <Form.Input
              style={{ width: 10, height: 20 }}
              control={Form.Select}
              defaultValue="id"
              options={criteria}
              value={searchCriteria}
              selection
              placeholder="Criteria"
              // onClick={() => setSearchTerm('')}
              onChange={(e) => {
                handleSelect(e)
              }}
            />
            <Form.Input
              style={{
                width: 200,
                height: 20,
                opacity: searchCriteria !== 'status' ? 0 : 1,
              }}
              control={Form.Select}
              options={status}
              value={searchTerm}
              selection
              placeholder="Status Selection"
              onChange={(e) => handleStatusSelect(e)}
            />
            <DebounceInput
              debounceTimeout={400}
              style={{ width: 350, height: 40 }}
              floated="right"
              className={styles.sel}
              label={{ icon: 'asterisk' }}
              labelPosition="right corner"
              type="text"
              placeholder="Search for a device with Dropdown Criteria"
              value={searchTerm}
              onChange={handleChange}
              disabled={searchCriteria === 'status'}
            />
            <Button
              primary
              onClick={() => {
                setSearchTerm('')
                handleClear()
                setSearchCriteria('id')
              }}
              style={{ width: 94, height: 40 }}
              floated="right"
            >
              Clear
            </Button>
          </Form.Group>
        </Form>
      </div>
      <br />
      <div className={styles.container}>
        <IntelMsg id="Device List" />
      </div>
      <Table sortable compact celled basic>
        <Table.Header style={{ backgroundColor: 'rgb(216, 231, 234)' }}>
          <Table.Row>
            <Table.HeaderCell>
              <IntelMsg id="Device Name" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="Device ID" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="imei" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="status" />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <IntelMsg id="actions" />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>{listItems}</Table.Body>
      </Table>
      <Table.Footer className={classes.footer} colSpan={2}>
        <Pagination
          floating="right"
          activePage={activePage + 1}
          onPageChange={(e, data) => onChange(e, data)}
          totalPages={noOfPages}
          firstItem={{
            content: <Icon name="angle double left" />,
            icon: true,
          }}
          lastItem={{
            content: <Icon name="angle double right" />,
            icon: true,
          }}
          prevItem={{
            content: <Icon name="angle left" />,
            icon: true,
          }}
          nextItem={{
            content: <Icon name="angle right" />,
            icon: true,
          }}
        />
      </Table.Footer>
      <div className={styles.actions}>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: primaryColor, color: 'white' }}
          onClick={() => {
            if (productName === 'tank') history.push('/Tank')
            else history.push('/cold')
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>
      <br />
      <br />
    </>
  )
}

const getActions = (
  deviceStatus,
  deviceConfigureOnClick,
  deviceTroubleshootOnClick,
) => (
  <Table.Cell width={3}>
    {deviceStatus === DEVICE_STATUS_ENUM.INSTALLED ? (
      <Button animated size="large" onClick={deviceTroubleshootOnClick}>
        <Button.Content className={classes.btn} hidden>
          <IntelMsg id="Troubleshoot" />
        </Button.Content>
        <Button.Content visible>
          <Icon name="settings" />
        </Button.Content>
      </Button>
    ) : null}
    {deviceStatus === DEVICE_STATUS_ENUM.CONFIGURED ? (
      <Button animated size="large" onClick={deviceTroubleshootOnClick}>
        <Button.Content className={classes.btn} hidden>
          <IntelMsg id="Troubleshoot" />
        </Button.Content>
        <Button.Content visible>
          <Icon name="settings" />
        </Button.Content>
      </Button>
    ) : null}
    <Button animated size="large" onClick={deviceConfigureOnClick}>
      <Button.Content className={classes.btn} hidden>
        {' '}
        Configure{' '}
      </Button.Content>
      <Button.Content visible>
        <Icon name="ellipsis horizontal" />
      </Button.Content>
    </Button>
  </Table.Cell>
)

// DeviceList.propTypes = {
//   status: PropTypes.oneOf([
//     DEVICE_STATUS_ENUM.INSTALLED,
//     DEVICE_STATUS_ENUM.CONFIGURED,
//     DEVICE_STATUS_ENUM.OFFLINE,
//     DEVICE_STATUS_ENUM.CONNECTED,
//   ]).isRequired,
// }

export default DeviceList
